import apiService from "apiService";
import React, { useState, useEffect } from "react";
import { showLoading, toast } from "view/component/Alert";
import Form from "../component/Form";

const KkkPuskesmas = () => {
  const [question, setquestion] = useState([]);
  const [value, setvalue] = useState([]);
  const [bulan, setbulan] = useState(1);

  const getKkkquesttion = async () => {
    let data = await apiService.get("dashboard/ref_kkk");
    if (data?.code == 200) {
      setquestion(data.data);
    }
  };

  useEffect(() => {
    getKkkquesttion();
    console.log(question);
  }, [question.length]);

  const onChange = (e, id) => {
    let newVal = value?.filter((x) => x.id !== id);
    let par = [
      ...newVal,
      {
        id: id,
        value: e,
      },
    ];
    setvalue(par);
  };

  const post = async () => {
    showLoading("menyimpan data");
    let param = {
      bulan: bulan,
      data: value,
      puskesmas_id: JSON.parse(localStorage.getItem("puskesmasProfile"))?.code,
    };
    let res = await apiService.post("dashboard/create_kkk", param);
    if (res.code == 200) {
      toast({ text: "berhasil disimpan", status: "success" });
    } else {
      toast({ text: "gagal", status: "danger" });
    }
  };
  const GenerateForm = (d) => {
    let element = [];
    if (d.length > 0) {
      d.map((a, k) => {
        element.push(
          <Form.Column lg={12} xs={12}>
            <Form.Radio
              labelWidth={10}
              label={a.name}
              value={value.find((e) => e.id == a.id)?.value}
              onChange={(e) => onChange(e.target.value, a.id)}
              name={a.name}
              options={[
                { value: 1, label: "ada" },
                { value: 0, label: "Tidak ada" },
              ]}
            />
          </Form.Column>
        );
      });
    }

    return element;
  };

  return (
    <div className="col-md-12 mt-2">
      <div className="card">
        <div className="card-body">
          <div className="row">
            <div className="col-md-2">Bulan</div>
            <select
              name="bulan"
              value={bulan}
              onChange={(e) => setbulan(e.target.value)}
              className="col-md-2"
            >
              <option value={1}>1</option>
              <option value={2}>2</option>
              <option value={3}>3</option>
              <option value={4}>4</option>
              <option value={5}>5</option>
              <option value={6}>6</option>
              <option value={7}>7</option>
              <option value={8}>8</option>
              <option value={9}>9</option>
              <option value={10}>10</option>
              <option value={11}>11</option>
              <option value={12}>12</option>
            </select>
          </div>
        </div>
      </div>
      <Form>
        {question.map((a, k) => {
          if (k > 0 && a.jenis_penilaian !== question[k - 1].jenis_penilaian) {
            return (
              <div className="card">
                <div className="card-header">{a.jenis_penilaian}</div>
                <div className="card-body">
                  {GenerateForm(
                    question.filter(
                      (e) => e.jenis_penilaian == a.jenis_penilaian
                    )
                  )}
                </div>
              </div>
            );
          } else if (k == 0) {
            return (
              <div className="card">
                <div className="card-header">{a.jenis_penilaian}</div>
                <div className="card-body">
                  {GenerateForm(
                    question.filter(
                      (e) => e.jenis_penilaian == a.jenis_penilaian
                    )
                  )}
                </div>
              </div>
            );
          }
        })}
        <div className="col-md-12 align-content-center">
          <button className="btn btn-success" onClick={() => post()}>
            simpan
          </button>
        </div>
      </Form>
    </div>
  );
};

export default KkkPuskesmas;
